import { Button } from "components/Button";
import { Card, CardHeader } from "components/Card";
import { Input } from "components/Input";
import { UserContext } from "context/UserContext";
import { useContext } from "react";
import { useLoaderData, useNavigate } from "react-router-dom";
import { Msag } from "services/MSAGRecord.d";
import RecordService from "services/RecordService";
import { formatSide } from "utils/helpers";

const recordService = new RecordService("msag");

export const loadRecord = async ({ params }): Promise<Msag> => {
  try {
    const res = await recordService.getRecords(
      {
        criterias: [{ field: "id", type: "=", value: params.id }],
      },
      "search",
    );
    console.log(res);
    if (res.status === 401) {
      throw new Error("Unable to fetch record");
    }

    if (!res.data?.message?.List?.length) {
      throw new Error("Record not found");
    }

    const record = res.data.message.List[0];
    return record;
  } catch (error: Error | any) {
    throw new Error(error.message || "Failed to load record");
  }
};

export default function MSAGRead() {
  const navigate = useNavigate();
  const { user } = useContext(UserContext);

  const record = useLoaderData() as Msag;

  function formatHighAndLowRange(range) {
    let formatted = range || "";
    if (record.HNP && range) {
      formatted = record.HNP + formatted;
    }
    if (record.HNE && range) {
      formatted = formatted + record.HNE;
    }
    return formatted;
  }

  if (!record) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <CardHeader
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        MSAG Record Details
      </CardHeader>
      <Card style={{ width: "100%", marginBottom: "20px" }}>
        <div style={{ padding: "20px", paddingBottom: "40px" }}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "100px",
            }}
          >
            {/* Left Column */}
            <div
              style={{ display: "flex", flexDirection: "column", gap: "8px" }}
            >
              <Input
                name="id"
                label="ID"
                value={record.id?.toString() || ""}
                readonly
                scale="s"
                labelSize="s"
              />
              <Input
                name="mcn"
                label="MSAG Community Name"
                value={record.MCN || ""}
                readonly
                scale="s"
                labelSize="s"
              />
              <Input
                name="streetName"
                label="Street Name"
                value={record.StreetName || ""}
                readonly
                scale="s"
                labelSize="s"
              />
              <Input
                name="streetSuffix"
                label="Street Suffix"
                value={record.StreetSuffix || ""}
                readonly
                scale="s"
                labelSize="s"
              />
              <Input
                name="prefixDir"
                label="Prefix Directional"
                value={record.PrefixDir || ""}
                readonly
                scale="s"
                labelSize="s"
              />
              <Input
                name="postDir"
                label="Post Directional"
                value={record.PostDir || ""}
                readonly
                scale="s"
                labelSize="s"
              />
              <Input
                name="countyId"
                label="County ID"
                value={record.CountyID || ""}
                readonly
                scale="s"
                labelSize="s"
              />
            </div>

            {/* Right Column */}
            <div
              style={{ display: "flex", flexDirection: "column", gap: "8px" }}
            >
              <Input
                name="state"
                label="State"
                value={record.State || ""}
                readonly
                scale="s"
                labelSize="s"
              />
              <Input
                name="lowRange"
                label="Low Range"
                value={formatHighAndLowRange(record.LowRange) || ""}
                readonly
                scale="s"
                labelSize="s"
              />
              <Input
                name="hiRange"
                label="High Range"
                value={formatHighAndLowRange(record.HiRange) || ""}
                readonly
                scale="s"
                labelSize="s"
              />
              {/* <Select
          label="Side"
          value={record.Side?.toString() || ""}
          name="side"
          disabled
          readableDisabled
          children={sideOptions.map((option) => (
            <CalciteOption key={option.value} value={option.value}>
            {option.label}
            </CalciteOption>
          ))}
          /> */}
              <Input
                name="side"
                label="Side"
                value={formatSide(record.Side?.toString()) || ""}
                readonly
                scale="s"
                labelSize="s"
              />
              <Input
                name="esn"
                label="ESN"
                value={record.esn || ""}
                readonly
                scale="s"
                labelSize="s"
              />
              <Input
                name="psapID"
                label="PSAP ID"
                value={record.psapID || ""}
                readonly
                scale="s"
                labelSize="s"
              />
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "20px",
            }}
          >
            <Button
              variant="outline"
              kind="brand"
              label="Close"
              onClick={() => navigate(-1)}
            >
              Close
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
}
